import React from 'react'

const Colombia = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="45"
            height="40"
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask
                id="y"
                width="32"
                height="30"
                x="1"
                y="1"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#C4C4C4"
                    d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
                />
            </mask>
            <g mask="url(#y)">
                <path fill="#F3D031" d="M26.1.6H-6.2v9.42h32.3V.6Z" />
                <path fill="#313F88" d="M26.1 10.02H-6.2v4.72h32.3v-4.72Z" />
                <path fill="#BC2433" d="M26.1 14.74H-6.2v4.72h32.3v-4.72Z" />
            </g>
        </svg>
    )
}

export default Colombia
